import { useSiteMessage } from '../hooks/queries/useSiteMessageQueries';
import SystemBanner from './SystemBanner';

// Renders the DB-driven system banner when active. Public: works on the login
// page too, before auth. Used both in the app shell and on logged-out routes.
function SiteMessageBanner() {
  const { data: siteMessage } = useSiteMessage();

  if (!siteMessage?.active || !siteMessage.message) {
    return null;
  }

  return (
    <SystemBanner
      // Remount on any content change so a dismissed banner re-shows when the
      // admin escalates or posts a new message (dismiss state lives in the
      // child and would otherwise persist for the session).
      key={`${siteMessage.message_type}:${siteMessage.title}:${siteMessage.message}`}
      message={siteMessage.message}
      type={siteMessage.message_type}
      dismissible
      customTitle={siteMessage.title}
    />
  );
}

export default SiteMessageBanner;
